const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderformActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "light",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m22.5 15h-13c-.827 0-1.5-.673-1.5-1.5v-3c0-.827.673-1.5 1.5-1.5h13c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5zm-13-5c-.276 0-.5.224-.5.5v3c0 .276.224.5.5.5h13c.276 0 .5-.224.5-.5v-3c0-.276-.224-.5-.5-.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m22.5 24h-13c-.827 0-1.5-.673-1.5-1.5v-3c0-.827.673-1.5 1.5-1.5h13c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5zm-13-5c-.276 0-.5.224-.5.5v3c0 .276.224.5.5.5h13c.276 0 .5-.224.5-.5v-3c0-.276-.224-.5-.5-.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m3 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m22.5 6h-13c-.827 0-1.5-.673-1.5-1.5v-3c0-.827.673-1.5 1.5-1.5h13c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5zm-13-5c-.276 0-.5.224-.5.5v3c0 .276.224.5.5.5h13c.276 0 .5-.224.5-.5v-3c0-.276-.224-.5-.5-.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m3 6c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m3 24c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderformActive);
export default __webpack_public_path__ + "static/media/orderform-active.f5b0baecbae458b107b1c870c4225ca3.svg";
export { ForwardRef as ReactComponent };